import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  specialTranslation,
  deletedList,
}: {
  specialTranslation: SpecialTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteSpecialTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`special-translations/${id}`, token);
  });

  const removeSpecialTranslation = () => {
    deleteSpecialTranslation.mutate(specialTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={specialTranslation.id}
      deletedList={deletedList}
      withImage
      image={specialTranslation.special?.image}
      sourceTitle={specialTranslation.special?.title}
      translation={specialTranslation?.title}
      lang={specialTranslation?.lang}
      editTo={`/special-translations/update/${specialTranslation.id}`}
      onDelete={removeSpecialTranslation}
      isDeleting={deleteSpecialTranslation.isLoading}
    />
  );
}

interface TableProps {
  specialTranslations: SpecialTranslation[];
  specialTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function SpecialTranslationsTable({
  specialTranslations,
  specialTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Offre" translationLabel="Titre">
      {specialTranslations?.map((specialTranslation) => (
        <TableBodyRowContent
          specialTranslation={specialTranslation}
          key={specialTranslation?.id}
          deletedList={specialTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
